<template>
  <stage-card-info-list>
    <template #header>Trend</template>
    <template #content>
      <screening-trend-breakdown :review="review" />
    </template>
  </stage-card-info-list>
</template>

<script>
import StageCardInfoList from '@/components/DashboardTab/StageCardInfoList';
import ScreeningTrendBreakdown from '@/components/ReviewSummary/ScreeningTrendBreakdown';
import { Review } from '@/models';

export default {
  name: 'StoppingCriteriaMetrics',
  components: {
    StageCardInfoList,
    ScreeningTrendBreakdown,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
};
</script>
